/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminJobStatisticsQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type AdminJobStatisticsQuery = { readonly __typename?: 'Query', readonly failedJobStatistics: ReadonlyArray<{ readonly __typename?: 'FailedJobStatistic', readonly context: string, readonly failure: string, readonly jobQueue: string, readonly jobType: string, readonly numberOfFailedJobs: number }> | null };


export const AdminJobStatisticsDocument = gql`
    query AdminJobStatistics {
  failedJobStatistics {
    context
    failure
    jobQueue
    jobType
    numberOfFailedJobs
  }
}
    `;

/**
 * __useAdminJobStatisticsQuery__
 *
 * To run a query within a React component, call `useAdminJobStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminJobStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminJobStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminJobStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>(AdminJobStatisticsDocument, options);
      }
export function useAdminJobStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>(AdminJobStatisticsDocument, options);
        }
export function useAdminJobStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>(AdminJobStatisticsDocument, options);
        }
export type AdminJobStatisticsQueryHookResult = ReturnType<typeof useAdminJobStatisticsQuery>;
export type AdminJobStatisticsLazyQueryHookResult = ReturnType<typeof useAdminJobStatisticsLazyQuery>;
export type AdminJobStatisticsSuspenseQueryHookResult = ReturnType<typeof useAdminJobStatisticsSuspenseQuery>;
export type AdminJobStatisticsQueryResult = Apollo.QueryResult<AdminJobStatisticsQuery, AdminJobStatisticsQueryVariables>;